module.exports = __webpack_public_path__ + "img/search.3069f4e4.svg";